import React from 'react';
import { ModuleInterface } from '../types';
import { Checkbox } from 'ui';

interface CheckboxFieldProps extends ModuleInterface {}

const CheckboxField: React.FC<CheckboxFieldProps> = ({ layout, ...field }) => {
    const commonProps = {
        url: field.endpoint,
        label: field.label,
        name: field.name,
        labelInValue: true,
        customLayout: layout,
        method: field?.method ?? 'GET',
        translation: field?.translation ?? '',
        validation: { required: field.required ?? false },
    };

    return <Checkbox {...commonProps} />;
};

export default CheckboxField;
